/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,react-hooks/exhaustive-deps */
import React, { useMemo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
// import Auth from "@aws-amplify/auth";
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector, connect } from 'react-redux';
import objectPath from 'object-path';
import { injectIntl } from 'react-intl';
import { useHtmlClassService } from '../../../_core/MetronicLayout';
import { toAbsoluteUrl } from '../../../../_helpers';
import { DropdownTopbarItemToggler } from '../../../../_partials/dropdowns';
import { ImagePlaceholder } from '../../../../../app/components/ImagePlaceholder';
import * as auth from '../../../../../app/modules/Auth/_redux/authRedux';

function UserProfileDropdown({ intl, setUser }) {
  const [projects, setProjects] = useState([]);
  // const dispatch = useDispatch()
  const { user } = useSelector(state => state.auth);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, 'extras.user.dropdown.style') ===
        'light',
    };
  }, [uiService]);

  useEffect(() => {
    async function getProjects() {
      const { data } = await axios.get('/projects');
      if (data) {
        setProjects(data);
        // const login = await Auth.currentAuthenticatedUser()

        // await Auth.updateUserAttributes(login, {
        //     'custom:project_id': `${data[0].id}`
        // })
        // const updatedUser = await Auth.currentAuthenticatedUser({ bypassCache: true })
        // dispatch(setUser({
        //     ...user,
        //     projectId: data[0].id,
        //     token: updatedUser.signInUserSession.idToken.jwtToken
        // }))
      }
    }

    getProjects();
  }, [user]);

  const toggleAlert = (_, evt) => {
    if (evt) evt.stopPropagation();
  };

  return (
    <Dropdown onToggle={toggleAlert} drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            'btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2'
          }
        >
          <span className="text-dark-50 font-weight-bolder font-size-h5 font-size-base d-none d-md-inline mr-3">
            {user.fullname}
          </span>
          <span className="symbol-label font-size-h5 font-weight-bold">
            {user.picture ? (
              <img
                src={user.picture}
                width={40}
                height={40}
                alt="user"
                style={{ borderRadius: 4 }}
              />
            ) : (
              <ImagePlaceholder classes="w-40px h-40px" />
            )}
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <>
          {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-4 bgi-size-cover bgi-no-repeat rounded-top"
              style={{ background: '#FF9600' }}
            >
              <div
                className="image-input image-input-outline mb-1 mr-3"
                id="kt_profile_avatar"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    '/media/users/blank.png'
                  )}`,
                }}
              >
                {user.picture ? (
                  <img
                    className="image-input-wrapper w-75px h-75px"
                    alt="user"
                    src={user.picture}
                  />
                ) : (
                  <ImagePlaceholder classes="image-input-wrapper w-75px h-75px" />
                )}
              </div>
              <div className="m-0 flex-grow-1 mr-3">
                <span className="d-block font-size-h5">{user.fullname}</span>
                <span style={{ color: '#58595B' }}>
                  {user.entityName} ({user.entityId})
                </span>
              </div>
            </div>
          )}
        </>
        <div className="navi navi-spacer-x-0 pt-5">
          <div className="navi-item px-4">
            <div className="form-group fv-plugins-icon-container">
              <label className="text-muted d-block">
                {intl.formatMessage({ id: 'CURRENT_PROJECT' })}
              </label>
              {projects.length && (
                <select
                  className="form-select min-w-200px"
                  defaultValue={projects[0].id}
                >
                  {projects.map(opt => (
                    <option key={opt.id} value={opt.id}>
                      {' '}
                      {opt.name}{' '}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>
          <div className="navi-separator mt-3"></div>

          <div className="navi-footer px-4 py-3">
            <Link
              to="/logout"
              className="btn btn-light-primary font-weight-bold"
            >
              {intl.formatMessage({ id: 'AUTH.LOGOUT.BUTTON' })}
            </Link>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default injectIntl(connect(null, auth.actions)(UserProfileDropdown));
